import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Enquire from "@/pages/Enquire";
import Admin from "@/pages/Admin";
import PresentMode from "@/pages/PresentMode";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id BEFORE normal routing (auth callback)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/book" element={<Booking />} />
      <Route path="/enquire" element={<Enquire />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/present" element={<PresentMode />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#18181B",
            border: "1px solid rgba(212,175,55,0.35)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
